'use strict';
import * as $j_app$002edata$002e$002dForm$002dQuantity from "./app.data.-Form-Quantity.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_FormQuantity$$anon$2(evidence$1$8) {
  this.aBt = null;
  this.aBt = evidence$1$8;
}
export { $c_Lapp_data_FormQuantity$$anon$2 as $c_Lapp_data_FormQuantity$$anon$2 };
$p = $c_Lapp_data_FormQuantity$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_FormQuantity$$anon$2;
/** @constructor */
function $h_Lapp_data_FormQuantity$$anon$2() {
}
export { $h_Lapp_data_FormQuantity$$anon$2 as $h_Lapp_data_FormQuantity$$anon$2 };
$h_Lapp_data_FormQuantity$$anon$2.prototype = $p;
$p.K9 = (function(quantity) {
  return new $j_app$002edata$002e$002dForm$002dQuantity.$c_Lapp_data_FormQuantity(quantity, this.aBt);
});
$p.ak = (function(src) {
  return this.K9(src);
});
var $d_Lapp_data_FormQuantity$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_FormQuantity$$anon$2, "app.data.FormQuantity$$anon$2", ({
  DE: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_FormQuantity$$anon$2 as $d_Lapp_data_FormQuantity$$anon$2 };
//# sourceMappingURL=app.data.-Form-Quantity$$anon$2.js.map
